export function getElementById(id: string) {
  return typeof document === "object" ? document.getElementById(id) : undefined;
}

export function getElementBoundaryById(id: string, boundary: "top" | "bottom" | "left" | "right") {
  const elt = getElementById(id);

  if (!elt) {
    return undefined;
  }

  const rect = elt.getBoundingClientRect();

  if (!rect) {
    return undefined;
  }

  return rect[boundary];
}
